import { render, staticRenderFns } from "./AddException.vue?vue&type=template&id=a1d95342&scoped=true"
import script from "./AddException.vue?vue&type=script&lang=js"
export * from "./AddException.vue?vue&type=script&lang=js"
import style0 from "./AddException.vue?vue&type=style&index=0&id=a1d95342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d95342",
  null
  
)

export default component.exports